
<template>
  <a-card :bordered="false">
    <component @onGoBack="handleGoBack" :record="record" :is="currentComponet"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import Info from '@/views/a-trade/project/detail/table/Info'

export default {
  name: 'TagInformation',
  components: {
    AInput,
    ATextarea,
    Info
  },
  data () {
    return {
      currentComponet: 'Info',
      record: ''
    }
  },
  methods: {
    handleGoBack () {
      this.record = ''
      this.currentComponet = 'Info'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'Info'
    }
  }
}
</script>
